import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

const ItemVIew = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  /////////////////////////////////////////////////////////////
      const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
        const permsLoaded = !!rawPerms;
        
        //✅ Permission checks (safe even if perms not yet loaded; will be false)
        const canView  = hasPermission("Item", "view");
        const canEntry = hasPermission("Item", "entry");
        const canEdit = hasPermission("Item", "edit");
        const canDel = hasPermission("Item", "del");
        /////////////////////////////////////////////////////////////
      

  useEffect(() => {
    fetchData();
  }, [branch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemMaster_list?branch=${branch}`);

      console.log("API Response:", response.data.itemList);
      setData(response.data.itemList);
      setFilteredData(response.data.itemList);
    } catch (error) {
      console.error("Error fetching itemList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.itemmaster_code || "").toLowerCase().includes(term) ||
       String(item.itemmaster_name || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };

  const handleDelete = async (id, branchCode) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
                title: "Submitting...",
                text: "Please wait while we process your request.",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
          await axios.delete(`https://rfs2.infraconsoft.net.in/api/itemMaster_delete/${id}/${branchCode}`);
          setData((prevData) => prevData.filter(
            (item) => !(item.itemmaster_code === id && item.branchCode === branchCode)
          ));
  
          setFilteredData((prevFilteredData) => prevFilteredData.filter(
            (item) => !(item.itemmaster_code === id && item.branchCode === branchCode)
          ));
  
          Swal.fire({
            title: "Deleted!",
            text: "Your record has been deleted.",
            icon: "success"
          });
        } catch (error) {
          console.error("Error deleting vehicle position:", error);
          Swal.fire({
            title: "Error!",
            text: "Failed to delete vehicle position.",
            icon: "error"
          });
        }
      }
    });
  };
  
  
if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Item Master</h2>
          <Time />
        </section>



        {/* Add New Button */}
          {canEntry && (
        <div className="add-new-container">
          <Link to={`/inventory/addNewItem`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add New
            </button>
          </Link>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Item Name or Code"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Part No.</th>
                <th>UOM</th>
                <th>Purchase UOM</th>
                <th>Price</th>
                {canEdit && (
                  <>
                <th>Modify</th>
                <th>Edit</th>
                </>
                    )}
                    {canDel && (
                      <th>Delete</th>
                    )}
                
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.branchCode}</td>
                  
                    <td>{item.itemmaster_code}</td>
                    <td>{item.itemmaster_name}</td>
                    <td>{item.itemmaster_drawingNumber}</td>
                    <td>{item.itemmaster_uom}</td>
                    <td>{item.itemMaster_purchaseUom}</td>
                    <td>
  {new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(item.itemmaster_price)}
</td>

                    {canEdit && (
                  <>
                <td>
                      <Link to={`/inventory/modifyitem/${item.itemmaster_code}/${item.branchCode}`}>
                        Modify
                      </Link>
                    </td>
                    <td>
                      <Link to={`/inventory/list_Itemserialnumber/${item.itemmaster_code}`}>
                        Edit
                      </Link>
                    </td>
                </>
                    )}
                
                     {canDel && (
                      <td className="del">
                      <i className="fa-solid fa-trash-can " onClick={() => handleDelete(item.itemmaster_code, item.branchCode,)}></i>
                    </td>
                    
                    )}
                    
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemVIew;
